import type { RentalPaymentMethod } from "./types/rental.types";

export const INSTALLABLE_PAYMENT_METHOD: RentalPaymentMethod = "CREDIT_CARD";

export const MIN_INSTALLMENTS = 1;

export const MAX_INSTALLMENTS = 12;

export const INSTALLMENT_OPTIONS = Array.from(
  { length: MAX_INSTALLMENTS - MIN_INSTALLMENTS + 1 },
  (_, index) => index + MIN_INSTALLMENTS,
);

export function supportsInstallments(method: RentalPaymentMethod): boolean {
  return method === INSTALLABLE_PAYMENT_METHOD;
}

export function formatInstallments(installments: number | null | undefined) {
  if (installments == null) return null;
  return installments <= MIN_INSTALLMENTS ? "à vista" : `${installments}x`;
}
